import {isoDocument} from '~/utils/document';
import {isoNavigator} from '~/utils/navigator';

export function isMobileBrowser(): boolean {
  return (
    Boolean(isoNavigator.userAgent) &&
    /(android|iphone|ipad|mobile|phone)/i.test(isoNavigator.userAgent)
  );
}

export function setCookie(
  name: string,
  value: string,
  duration?: number,
): void {
  const expires = duration
    ? new Date(Date.now() + duration).toUTCString()
    : 'session';
  isoDocument.cookie = `${name}=${value};expires=${expires};path=/`;
}

export function getCookie(key: string): string | null {
  try {
    const value = new RegExp(`(${key})=([^;]+)`).exec(isoDocument.cookie);
    return value ? value[2] : null;
  } catch (_ignore) {
    return null;
  }
}
